(function () {
  'use strict';

  // --- Helpers ---
  function norm(s) {
    return (s || '').toString().trim().toLowerCase();
  }

  function isStep1MaterialBox(box) {
    if (!box) return false;

    // Prefer YMQ's data-name if present
    const dataName = norm(box.getAttribute('data-name'));
    if (
      dataName.includes('step 1') &&
      (dataName.includes('customisation material') || dataName.includes('customization material'))
    ) return true;

    // Fallback: visible title text inside the option title
    const title = box.querySelector('.ymq-option-title');
    const titleText = norm(title ? title.textContent : '');
    if (
      titleText.includes('step 1') &&
      (titleText.includes('customisation material') || titleText.includes('customization material'))
    ) return true;

    return false;
  }

  function cleanOneBox(box) {
    if (!box) return;

    // 1) Hide/remove the price span
    box.querySelectorAll('.ymq_option_price_span').forEach((el) => {
      el.style.display = 'none';
      el.hidden = true;
      el.textContent = '';
    });

    // 2) Remove "+" if it was injected into other text spans
    // (We keep Vinyl/Glitter/etc.)
    box.querySelectorAll('.ymq_option_text_span, .ymq_label, .ymq-options-button-label').forEach((el) => {
      // Only adjust if it looks like it contains a plus + price pattern
      const t = el.textContent || '';
      if (t.includes('+') && (t.includes('$') || t.match(/\b\d+(\.\d{1,2})?\b/))) {
        // Remove only standalone "+" characters (don’t touch "C++" etc.)
        el.textContent = t.replace(/\s*\+\s*/g, ' ').replace(/\s{2,}/g, ' ').trim();
      }
    });

    // 3) Prevent overlap by making label layout stable
    box.querySelectorAll('.ymq-options-button-label').forEach((label) => {
      label.style.display = 'flex';
      label.style.alignItems = 'center';
      label.style.justifyContent = 'center';
      label.style.gap = '10px';
      label.style.whiteSpace = 'nowrap';
    });
  }

  function run() {
    const ymqRoot = document.querySelector('#MainContent #ymq-box') || document.querySelector('#ymq-box');
    if (!ymqRoot) return;

    ymqRoot.querySelectorAll('.ymq-options-box').forEach((box) => {
      if (isStep1MaterialBox(box)) cleanOneBox(box);
    });
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', run);

  // Re-run after YMQ / theme re-renders
  const mo = new MutationObserver(() => run());
  window.addEventListener('load', () => {
    mo.observe(document.body, { childList: true, subtree: true });
    run();
  });
})();
